const PersonalDescription = () => {
  return (
    <div className="mt-5 sm:mt-0">
      <h1 className="md:text-lg font-semibold text-pink-500">Description</h1>
      <p className="md:text-lg mt-2 text-gray-600">
        I am a detail oriented developer with over four years of experience
        building and maintaining beautiful, responsive websites.
      </p>
    </div>
  );
};

export default PersonalDescription;
